import {
  AccountIcon,
  DetailIcon,
  HomeIcon,
  LuckySpinIcon,
  StartIcon,
  SupportIcon,
} from './icons';

/**
 * The app's primary destinations, shared by the mobile bottom nav, the mobile
 * menu and the desktop top nav so the three cannot disagree. Order is deliberate.
 */
export const NAV_ITEMS = [
  { path: '/home', labelKey: 'home', Icon: HomeIcon, bottomNav: true },
  { path: '/detail', labelKey: 'detail', Icon: DetailIcon, bottomNav: true },
  { path: '/order', labelKey: 'start', Icon: StartIcon, bottomNav: true },
  { path: '/support', labelKey: 'support', Icon: SupportIcon, bottomNav: true },
  { path: '/lucky-spin', labelKey: 'lucky_spin', Icon: LuckySpinIcon, bottomNav: false },
  { path: '/account', labelKey: 'account', Icon: AccountIcon, bottomNav: true },
];

/**
 * What the mobile bottom bar shows — everything except entries flagged out.
 *
 * Six items leave roughly 61px each at 390px. That is below both the iOS
 * (max 5 tabs) and Material (3–5 destinations) guidance, and narrow enough
 * that a two-word label wraps onto a second line: the bar sets `leading-none`,
 * so a wrapped label collides with the single-line ones beside it.
 *
 * Lucky Spin is a promotion rather than a core destination, so it is the entry
 * that gives way. It stays reachable from the roomy desktop nav, the vertical
 * mobile menu, and its own feature row on the Account page — only the bottom
 * bar drops it.
 */
export const BOTTOM_NAV_ITEMS = NAV_ITEMS.filter((item) => item.bottomNav);
